export const setValueFalseWidget = async (set, handlePage) => {
  await set('value', false);
  handlePage(1);
};
